import { StyledDiamond } from './Diamond.styles'

const Diamond: React.FC = (): JSX.Element => {
    return <StyledDiamond />
}

export default Diamond
